import React from 'react';

/**
 * Password strength meter component
 * @param {string} password - The password to evaluate
 * @returns {JSX.Element} - The password strength meter component
 */
const PasswordStrengthMeter = ({ password }) => {
  // Calculate the strength score (0-4)
  const calculateStrength = (password) => {
    if (!password) return 0;
    
    let score = 0;
    
    // Length check
    if (password.length >= 8) score++;
    if (password.length >= 12) score++;
    
    // Complexity checks
    if (/[A-Z]/.test(password)) score++; // Has uppercase
    if (/[0-9]/.test(password)) score++; // Has number
    if (/[^A-Za-z0-9]/.test(password)) score++; // Has special char
    
    // Cap the score at 4
    return Math.min(4, score);
  };
  
  const strength = calculateStrength(password);
  
  // Labels for each strength level
  const strengthLabels = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];
  
  // Colors for each strength level
  const strengthColors = ['#ff4d4f', '#faad14', '#fadb14', '#52c41a', '#1890ff'];
  
  // Width percentages for the meter (20%, 40%, 60%, 80%, 100%)
  const strengthWidth = `${(strength + 1) * 20}%`;
  
  return (
    <div className="my-3">
      <div className="h-2 w-full bg-gray-200 rounded-full">
        <div 
          className="h-2 rounded-full transition-all duration-300"
          style={{ 
            width: strengthWidth, 
            backgroundColor: strengthColors[strength] 
          }}
        ></div>
      </div>
      
      <div className="mt-1 text-xs flex justify-between">
        <span 
          className="font-medium"
          style={{ color: strengthColors[strength] }}
        >
          {strengthLabels[strength]}
        </span>
        
        {strength < 3 && (
          <span className="text-gray-500">
            {strength < 2 
              ? 'Add uppercase letters, numbers, and special characters'
              : 'Add special characters and increase length'}
          </span>
        )}
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;